import axios from 'axios'
// import router from '../router'
var VueCookie = require('vue-cookie')

// alert(process.env.VUE_APP_SERVER_ADDRESS)
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_SERVER_ADDRESS

class Send {
  static submit (requestType, url, data = null) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      axios[requestType](url, data)
        .then(response => {
          // this.onSuccess(response.data)
          resolve(response.data)
        })
        .catch(error => {
          if (typeof (error.response) === 'undefined') {
            // eslint-disable-next-line no-undef
            swal(
              'خطا!',
              'خطایی در ارسال کد امنیتی وب سایت رخ داده!',
              'warning', {
                button: 'باشه'
              })
            reject(error)
          } else if (error.response.status === 500) {
            // eslint-disable-next-line no-undef
            swal(
              'خطا!',
              'خطایی سمت سرور رخ داده وامکان اجرای دستور شما فراهم نیستد',
              'warning', {
                button: 'باشه'
              })
          } else if (error.response.status === 404) {
            // eslint-disable-next-line no-undef
            swal(
              'خطا!',
              'داده ی درخواستی شما در دیتابیس پیدا نشد در صورتی که فکر می کنید خطایی رخ داده به برنامه نویس اطلاع دهید تا در اسرع وقت مشکل بررسی شود!',
              'warning', {
                button: 'باشه'
              })
            // router.push({ name: 'notFound' })
          } else if (error.response.status === 403) {
            // eslint-disable-next-line no-undef
            swal(
              'عدم دسترسی!',
              'شما دسترسی لازم برای درخواستی را که ارسال کرده اید ندارید!',
              'warning', {
                button: 'باشه'
              })
            // router.push({ name: '403' })
          } else if (error.response.status === 401) {
            VueCookie.$cookies.remove('XSRF-TOKEN')
            VueCookie.$cookies.remove('laravel_session')
            // eslint-disable-next-line no-undef
            swal(
              'عدم دسترسی!',
              'در احراز هویت شما مشکلی به وجود آمده لطفا ازسیستم خارج و دوباره وارد شوید!',
              'warning', {
                button: 'باشه'
              })
          } else if (error.response.status === 419) {
            // eslint-disable-next-line no-undef
            swal(
              'مشکل در کد امنیتی!',
              'کدامنیتی ارسال شده توسط درخواست شما صحیح نمیباشد لطفا برای حل مشکل کوکی ها ی مرورگر خود را پاک کنید سپس دوباره لاگین کنید!!',
              'warning', {
                button: 'باشه'
              })
          } else {
            reject(error.response.data)
          }
        })
    })
  }
}
export default Send
